export const STEPPER_STEP_UPLOADFILE = 0
export const STEPPER_STEP_MODIFY_IMAGE = 1
export const STEPPER_STEP_MODIFY_HTML = 2
export const STEPPER_STEP_ADD_METADATA = 3
export const UPLOAD_PDF_PROGRESS_MESSAGE = 'Converting PDF to IMAGE. This may take a while'
export const UPLOAD_IMAGE_PROGRESS_MESSAGE = 'Converting IMAGE to HTML. This may take a while'